import { CustomServerError } from './CustomServerError'

export class TaxOfficeAddressConfirmationError extends CustomServerError {}
